<script lang="ts">
    import './assets/scss/main.scss';
    import Router, {push} from "svelte-spa-router";
    import {routes} from "./routes.ts"

    function conditionsFailed(e) {
        if (e.detail.location === '/' || e.detail.location === '/compte/demande' || e.detail.location === '/compte/mot-de-passe')
            push('/commande/ajout');
        else
            push('/')
    }

</script>

<div class="container is-widescreen pb-6 mb-6">
    <Router {routes} on:conditionsFailed={conditionsFailed} />
</div>



